"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CopyLink = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _types = require("../../types");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CopyLink = props => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    ...getTestIdProps(_types.TestId.CopyLinkContent),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CopyLinkInputButton, {
      ...props
    })
  });
};
exports.CopyLink = CopyLink;
var _default = exports.default = CopyLink;
